import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { User } from 'src/app/models/user.model';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { UsersStore } from 'src/app/features/users/users-store';
import { ContactDisplayComponent } from '../contact-display/contact-display.component';
import { RecipientsDisplayComponent } from 'src/app/shared/components/recipients-display/recipients-display.component';
import { DistributionGroup } from 'src/app/models/distribution-group.model';
import { DistributionGroupSquareComponent } from 'src/app/features/questionnaires/features/table-grid/features/questionnaire-data/components/distribution-group-square/distribution-group-square';

@Component({
    selector: 'que-group-display',
    imports: [CommonModule, TranslateDirective, TranslatePipe, ContactDisplayComponent, RecipientsDisplayComponent, DistributionGroupSquareComponent],
    templateUrl: './group-display.component.html',
    styleUrls: ['./group-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GroupDisplayComponent {
  @Input()
  group?: DistributionGroup;
  @Input()
  displayUsers = true;
  @Input()
  isSelect: boolean = false;
  @Input()
  canDelete: boolean = true;
  @Output()
  deleteEvent = new EventEmitter<DistributionGroup>();
  #usersStore = inject(UsersStore);
  color: string = "#B7C7FC";
  open = false;
  delete() {
    this.deleteEvent.emit(this.group);
    if (this.group) {
      this.#usersStore.RemoveGroup(this.group);
    }
  }
  openGroup() {
    this.open = !this.open;
  }
}
